import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import loginBackgroundImage from '../../assets/images/bg_login.png'
import { url } from 'inspector';
export const LayoutLogin: React.FC = () => {
    useEffect(() => {
        document.body.classList.add('login-layout-body');
        return () => {
            document.body.classList.remove('login-layout-body');
        };
    }, []);

    const date = new Date();
    const currentYear = date.getFullYear() || 2025;
    return (
        <div className="relative h-screen w-screen overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${loginBackgroundImage})` }}
            ></div>
            <div className="relative z-10 h-full overflow-y-auto overflow-x-hidden">
                <Outlet />
            </div>
            <div className="z-30 pointer-events-none fixed bottom-5 w-full">
                <div className="flex justify-center text-sm text-white">
                    Copyright © {currentYear} EMG All rights reserved.
                </div>
            </div>
            {/* Tailwind Animation */}
            <style>
                {`
          @keyframes bgMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .animate-bg-move {
            animation: bgMove 90s infinite linear;
          }
        `}
            </style>
        </div>
    );
};

